import { MutationTree } from 'vuex';
import { WalletInfoInterface } from './wallet.type';

export const mutations: MutationTree<WalletInfoInterface> = {
  SET_WALLET_INFO(state, payload) {
    state.walletInfo = payload;
  },
};
